import { render, staticRenderFns } from "./TruncatedTextCell.vue?vue&type=template&id=c7bea770&scoped=true"
import script from "./TruncatedTextCell.vue?vue&type=script&lang=ts"
export * from "./TruncatedTextCell.vue?vue&type=script&lang=ts"
import style0 from "./TruncatedTextCell.vue?vue&type=style&index=0&id=c7bea770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bea770",
  null
  
)

export default component.exports